/*
 * VIP gate — browser side.
 *
 * WHY THIS IS HERE AT ALL: Shopify Liquid cannot read the query string, so a
 * theme cannot check a typed password on the server. The customer-tag route in
 * snippets/vip-gate.liquid is server-side and real; this is the password route
 * and it is a SOFT gate — the products are in the page behind a hidden
 * container, reachable with developer tools by anyone who looks.
 *
 * The password itself is never in the page. Liquid prints a SHA-256 of it and
 * this hashes what was typed to compare, so View Source does not hand it over.
 */
(function () {
  var gate = document.querySelector('[data-vip-gate]');
  var content = document.querySelector('[data-vip-content]');
  if (!gate || !content) return;

  var STORE_KEY = 'majoritys:vip_unlocked';
  var expected = (gate.getAttribute('data-vip-hash') || '').toLowerCase();
  var form = gate.querySelector('[data-vip-form]');
  var input = gate.querySelector('#VipKey');

  function unlock(remember) {
    gate.hidden = true;
    content.hidden = false;
    if (remember) {
      try { window.localStorage.setItem(STORE_KEY, expected); } catch (e) {}
    }
  }

  // Returning member: only accept a stored value matching the CURRENT password,
  // so changing the password logs everyone back out rather than silently not.
  try {
    if (expected && window.localStorage.getItem(STORE_KEY) === expected) {
      unlock(false);
      return;
    }
  } catch (e) {}

  function sha256(text) {
    if (!(window.crypto && window.crypto.subtle && window.TextEncoder)) {
      return Promise.reject(new Error('no subtlecrypto'));
    }
    return window.crypto.subtle
      .digest('SHA-256', new TextEncoder().encode(text))
      .then(function (buf) {
        return Array.prototype.map
          .call(new Uint8Array(buf), function (b) { return ('00' + b.toString(16)).slice(-2); })
          .join('');
      });
  }

  function fail() {
    var err = gate.querySelector('.vip-gate__error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'vip-gate__error';
      err.setAttribute('role', 'alert');
      var f = gate.querySelector('[data-vip-form]');
      if (f && f.parentNode) f.parentNode.insertBefore(err, f);
    }
    err.textContent = "That password wasn't right. Check your welcome email and try again.";
    if (input) {
      input.value = '';
      input.focus();
    }
  }

  if (!form) return;
  form.addEventListener('submit', function (e) {
    // Never let it submit: a GET would put the password in the URL, where it
    // would be shared, logged and indexed.
    e.preventDefault();
    var typed = (input && input.value || '').trim();
    if (!typed) return;

    sha256(typed)
      .then(function (hash) {
        if (hash.toLowerCase() === expected) unlock(true);
        else fail();
      })
      .catch(function () {
        // SubtleCrypto needs a secure context. On http:// there is no way to
        // compare without printing the password, so say so rather than fail mute.
        fail();
      });
  });
})();
